<template>
    <div class="course-learning">
      <label class="home-class-chinese-label">课程学习</label><br/>
      <label class="home-class-english-label">Course Learning</label><br/>
      <div class="center-buttom">
        <div class="typing-img-buttom">
          <b-img class="typing-img-buttom-img" :src="require('../../assets/HomePage/typing.png')" @click.prevent="toTyping" v-bind="typingProps"/>
          <label class="typing-img-buttom-label" @click.prevent="toTyping">{{ $t('Home.typing') }}</label>
        </div>
        <div class="typing-label-buttom">
          <label class="typing-label-buttom-label">{{ $t('Home.typingExplain') }}</label><br/>
          <button class="typing-label-buttom-buttom" @click.prevent="toTyping">{{ $t('Home.go') }}{{ afterGo }}</button>
        </div>
        <div class="word-img-buttom">
          <b-img class="word-img-buttom-img" :src="require('../../assets/HomePage/word.png')" @click.prevent="toWord" v-bind="wordProps"/>
          <label class="typing-img-buttom-label" @click.prevent="toWord">{{ $t('Home.word') }}</label>
        </div>
        <div class="word-label-buttom">
          <label class="typing-label-buttom-label">{{ $t('Home.wordExplain') }}</label><br/>
          <button class="typing-label-buttom-buttom" @click.prevent="toWord">{{ $t('Home.go') }}{{ afterGo }}</button>
        </div>
      </div>
    </div>
</template>

<script>
import Vue from 'vue'

const CourseLearning = Vue.extend({
  name: 'CourseLearning',
  data: function () {
    return {
      imageSource: require('../../assets/HomePage/bulletinDefaultImage.png'),
      typingProps: { blank: false, width: 220, height: 122, class: 'm1' },
      wordProps: { blank: false, width: 176, height: 166, class: 'm1' },
      afterGo: '  >>'
    }
  },
  methods: {
    toTyping () {
      this.$router.push({
        name: 'typing'
      })
    },
    toWord () {
      this.$router.push({
        name: 'vocabulary'
      })
    }
  }
})
export default CourseLearning
</script>

<style>
.home-class-chinese-label {
  font-size: 34px;
}
.home-class-english-label {
  font-size: 28px;
}
.center-buttom {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  height: 410px;
  width: 1024px;
  background-image: url('../../assets/HomePage/centerButtom.png');
  background-size: 1024px 410px;
  margin-bottom: 80px;
}
.typing-img-buttom {
  position: relative;
  left: 117px;
  top: 30px;
  height: 260px;
  width: 260px;
  border-radius: 130px;
  background-color: white;
  cursor: pointer;
}
.typing-img-buttom-img {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-60%, -65%);
  cursor: pointer;
}
.typing-img-buttom-label {
  position: absolute;
  bottom: 26px;
  font-weight: bold;
  left: 50%;
  font-size: 30px;
  transform: translateX(-50%);
  cursor: pointer;
}
.word-img-buttom {
  position: absolute;
  right: 117px;
  top: 30px;
  height: 260px;
  width: 260px;
  border-radius: 130px;
  background-color: white;
  cursor: pointer;
}
.word-img-buttom-img {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-70%, -65%);
  cursor: pointer;
}
.typing-label-buttom {
  position: absolute;
  bottom: 40px;
  left: 247px;
  transform: translateX(-50%);
}
.typing-label-buttom-label {
  font-size: 16px;
  color: white;
}
.typing-label-buttom-buttom {
  height: 35px;
  width: 150px;
  background-color: white;
  color: black;
  border-radius: 17.5px;
  font-size: 18px;
  font-weight: bold;
  border: none;
}
.word-label-buttom {
  position: absolute;
  bottom: 40px;
  right: 247px;
  transform: translateX(50%);
}
</style>
